import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { listarPacientes } from "../api";
import "./PacienteListLogopedia.css";

export default function PacientesListLogopedia() {
  const navigate = useNavigate();
  const basePath = "/logopedia";

  const [typed, setTyped] = useState("");
  const [q, setQ] = useState("");
  const [page, setPage] = useState(1); // paginación LOCAL
  const [loading, setLoading] = useState(false);

  const [allItems, setAllItems] = useState([]); // acumulado backend
  const [view, setView] = useState({ items: [], total: 0, pages: 1, page: 1 });

  const [current, setCurrent] = useState(0);

  // --- buscador con debounce ---
  useEffect(() => {
    const t = setTimeout(() => {
      setQ(typed);
      setPage(1);
    }, 400);
    return () => clearTimeout(t);
  }, [typed]);

  // ✅ cargar TODAS las páginas del backend SIN filtrar por servicios
  useEffect(() => {
    let alive = true;

    (async () => {
      setLoading(true);
      try {
        const pageSizeBackend = 50;
        let p = 1;
        let acc = [];

        while (alive) {
          const r = await listarPacientes({ q, page: p, page_size: pageSizeBackend });
          const items = Array.isArray(r?.items) ? r.items : [];
          acc = acc.concat(items);

          const backendHasPages = Number.isFinite(Number(r?.pages)) && Number(r.pages) > 0;
          if (backendHasPages) {
            if (p >= Number(r.pages)) break;
          } else {
            if (items.length < pageSizeBackend) break;
          }

          p += 1;
        }

        if (!alive) return;
        setAllItems(acc);
      } catch (e) {
        console.error("❌ Error listarPacientes (logopedia):", e);
        if (!alive) return;
        setAllItems([]);
      } finally {
        if (alive) setLoading(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, [q]);

  // --- construir la vista paginada LOCAL ---
  useEffect(() => {
    const pageSizeLocal = 10;
    const total = allItems.length;
    const pages = Math.max(1, Math.ceil(total / pageSizeLocal));
    const safePage = Math.min(Math.max(1, page), pages);

    const start = (safePage - 1) * pageSizeLocal;
    const end = start + pageSizeLocal;

    setView({
      items: allItems.slice(start, end),
      total,
      pages,
      page: safePage,
    });

    setCurrent(0);
  }, [allItems, page]);

  const hasPrev = view.page > 1;
  const hasNext = view.page < (view.pages || 1);

  const goView = (id) => navigate(`/paciente/${id}`);

  return (
    <div className="pl-wrap">
      <div className="pl-tools">
        <input
          type="search"
          placeholder="Buscar pacientes de Logopedia…"
          value={typed}
          onChange={(e) => setTyped(e.target.value)}
        />
        <span className="pl-count">
          {loading ? "Cargando…" : `${view.total} resultado${view.total === 1 ? "" : "s"}`}
        </span>
      </div>

      {/* 🖥️ Tabla escritorio */}
      <div className="desktop-only pl-table-scroll">
        <table className="pl-table">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Nacimiento</th>
              <th>Sexo</th>
              <th>Colegio</th>
              <th>Servicios</th>
              <th>Tutor</th>
              <th>Contacto</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {!loading && (!view.items || view.items.length === 0) && (
              <tr>
                <td colSpan={8} className="pl-empty">
                  Sin resultados
                </td>
              </tr>
            )}

            {view.items?.map((p) => (
              <tr key={p.id}>
                <td>{p.nombre}</td>
                <td>{p.fechaNacimiento || p.fecha_nacimiento || "-"}</td>
                <td>{p.sexo || "-"}</td>
                <td>{p.colegio || "-"}</td>
                <td>
                  {Array.isArray(p.servicios)
                    ? p.servicios.join(", ")
                    : typeof p.servicios === "string"
                    ? p.servicios
                    : "-"}
                </td>
                <td>{p.tutor?.nombre || "-"}</td>
                <td className="pl-actions">
                  <button className="btn-view" title="Ver" onClick={() => goView(p.id)}>
                    <i className="fa fa-eye" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* 📱 Carrusel móvil */}
      <div className="mobile-only mobile-carrusel">
        {loading ? (
          <div className="pl-empty">Cargando pacientes...</div>
        ) : view.items.length === 0 ? (
          <div className="pl-empty">No hay pacientes disponibles.</div>
        ) : (
          <>
            <button
              className="arrow left"
              onClick={() => setCurrent((prev) => (prev === 0 ? view.items.length - 1 : prev - 1))}
              disabled={view.items.length <= 1}
            >
              <i className="fa-solid fa-chevron-left"></i>
            </button>

            <div className="card-cita">
              <h3>{view.items[current]?.nombre}</h3>
              <p>
                <strong>Nacimiento:</strong>{" "}
                {view.items[current]?.fechaNacimiento || view.items[current]?.fecha_nacimiento || "-"}
              </p>
              <p>
                <strong>Sexo:</strong> {view.items[current]?.sexo || "-"}
              </p>
              <p>
                <strong>Colegio:</strong> {view.items[current]?.colegio || "-"}
              </p>
              <p>
                <strong>Servicios:</strong>{" "}
                {Array.isArray(view.items[current]?.servicios)
                  ? view.items[current]?.servicios.join(", ")
                  : typeof view.items[current]?.servicios === "string"
                  ? view.items[current]?.servicios
                  : "-"}
              </p>
              <p>
                <strong>Tutor:</strong> {view.items[current]?.tutor?.nombre || "-"}
              </p>

              <div className="pl-actions mobile-actions">
                <button className="btn-view" title="Ver" onClick={() => goView(view.items[current].id)}>
                  <i className="fa fa-eye" />
                </button>
              </div>
            </div>

            <button
              className="arrow right"
              onClick={() => setCurrent((prev) => (prev === view.items.length - 1 ? 0 : prev + 1))}
              disabled={view.items.length <= 1}
            >
              <i className="fa-solid fa-chevron-right"></i>
            </button>
          </>
        )}
      </div>

      {/* 📄 Paginación */}
      <div className="pl-pager">
        <button disabled={!hasPrev} onClick={() => setPage((p) => p - 1)}>
          ◀ Anterior
        </button>
        <span>
          Página {view.page} de {view.pages}
        </span>
        <button disabled={!hasNext} onClick={() => setPage((p) => p + 1)}>
          Siguiente ▶
        </button>
      </div>
    </div>
  );
}
